import ReviewConstants from 'notebook/reviews/ReviewConstants';
import {Review} from 'notebook/reviews/ReviewCriteriaConstants';
import {AssayRunSchema} from 'results/assay-schemas/AssaySchemaConstants';
import {AssayRun} from 'results/assays/AssayRecordConstants';
import {Optional} from 'util/Types';

export default function canSetValidation({
  assayRun,
  assayRunSchema,
  attachedForReview,
  review,
}: {
  assayRun?: AssayRun;
  assayRunSchema?: AssayRunSchema;
  attachedForReview?: boolean;
  review: Optional<Review>;
}): boolean {
  if (attachedForReview == null) {
    attachedForReview = true;
  }
  if (
    !attachedForReview ||
    (assayRun && !assayRun.permissions.writable) ||
    (assayRunSchema &&
      (assayRunSchema.automationInputFileConfigs.length || assayRunSchema.automationOutputFileConfigs.length))
  ) {
    return false;
  }
  if (review) {
    return !ReviewConstants.LOCKED_STATUSES.includes(review.status);
  }
  return true;
}
